import {useEffect, useRef, useState} from "react";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import * as PropertyBucket from "../../Properties/Properties.js";
import {BlockUnsavedForm} from "../BlockUnsavedForm/BlockUnsavedForm";
import {FormActionButtons} from "../FormActionButtons/FormActionButtons";
import Input from '../Input/Input';
import SelectCustom from '../SelectCustom/SelectCustom';
import {unblockRoute} from "../../Services/BlockChangeRoute";

export const FormSchema = Yup.object().shape({
    questionName: Yup.string()
        .min(1)
        .max(2000, PropertyBucket.tooLongQuestionTextMessage(2000), 2000)
        .required(PropertyBucket.getQuestionNameMustBeChosen()),
    blocks: Yup.array().min(1, "Wybierz blok").max(1, "Wybierz blok"),
});

export const QuestionForm = (props) => {
    const onKeyDown = (ev) => {
        // Prevent submitting form with ENTER, when there are multiple types of form fields
        if ((ev.charCode || ev.keyCode) === 13) {
            ev.preventDefault();
        }
    };
    const selectBlockRef = useRef();
  const [isControlsDisabled, setControlsDisabled] = useState(false);
  const [violations, setViolations] = useState(null);

  useEffect (() => {
    const violationsList = props.violations.length > 0 ? props.violations?.map(v => v.violation + '. ') : null;
    setViolations(violationsList);
  }, [props.violations]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        questionName: props.questionName || "",
        blocks: props.blocks || [],
        activeBlock: props.activeBlock || [],
        questionCode: props.questionCode || "",
      }}
      validationSchema={FormSchema}
      validateOnChange={false}
      validateOnBlur={false}
      onSubmit={(values) => {
        unblockRoute();
        props.handleSave(values);
        setControlsDisabled(true);
      }}
    >
      {({ values, errors, setFieldValue }) => {
        return (
          <>
            <BlockUnsavedForm />
            <Form
              onChange={() => {
                isControlsDisabled && setControlsDisabled(false); 
                setViolations(null);
              }}
              onKeyDown={onKeyDown}
            >
              <div className='row'>
                <div className='col-md-6'>
                  <Input
                    disabled={true}
                    name='questionCode'
                    inputId='code'
                    className='form-control'
                    label='Kod pytania'
                    formik
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-12'>
                  <Input
                    formik
                    rows='3'
                    name='questionName'
                    inputId='questionName'
                    className='form-control'
                    component='textarea'
                    label='Pytanie'
                    chartsCount={values.questionName.length}
                    onChange={(e) => setFieldValue("questionName", e.target.value)}
                    errorId='questionNameAlert'
                    error={errors.questionName && errors.questionName || violations}
                    maxLength={2000}
                    invalid={errors.questionName || violations}
                  />
                </div>
              </div>
              <div className='row'>
                <div className='col-md-6'>
                  <SelectCustom
                    invalid={errors.blocks}
                    error={errors.blocks && errors.blocks}
                    errorId='blockAlert'
                    label='Blok'
                    id='blockSlectId'
                    dropdownId='blockDropdownId'
                    labelField='blockItem'
                    values={values.activeBlock}
                    placeholder='Bloki'
                    valueField='blockItem'
                    options={props.blocks}
                    onChange={(values) => {
                      isControlsDisabled && setControlsDisabled(false);
                      props.handleBlockSelected()
                      setFieldValue("blocks", values);
                    }}
                    sortBy='blockId'
                    parentRef={selectBlockRef}
                  />
                </div>
              </div>

              <FormActionButtons
                abortPath='/search_question'
                disabled={isControlsDisabled}
                context='pytanie'
              />
            </Form>
          </>
        );
      }}
    </Formik>
  );
};
